import React from 'react'
import {
  cardBaseStyle,
  cardContainerStyle,
  seeAllStepsButtonSx,
  getStackCardStyle,
  numberCircleStyle,
  titleStyle,
  descStyle,
  headerStyle,
  completedNumberCircleStyle,
  cardGradientStyle
} from './onboardingCardStyles'
import Button from '@mui/material/Button'
import { Box, Stack, Typography } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import { OnboardingStepStatus } from '../../../api/onboardingApiSlice'

export function OnboardingCard({ title, description, status, stackOffset, isTop, onSeeAll, total, isDisabled }) {
  const isStepCompleted = status === OnboardingStepStatus.COMPLETED

  const dynamicCardStyles = {}
  if (isDisabled && !isStepCompleted) {
    dynamicCardStyles.opacity = 0.6
  }

  return (
    <div className={cardContainerStyle}>
      <div
        className={`${cardBaseStyle} ${getStackCardStyle(stackOffset, total, isTop, isStepCompleted)}`}
        style={dynamicCardStyles}
      >
        <div className={cardGradientStyle} />
        <Box display={'flex'} flexDirection='column' width={'100%'} rowGap={1}>
          <Box display={'flex'} columnGap={2} alignItems={'center'} justifyContent={'space-between'} width={'100%'}>
            <Stack rowGap={1} width={onSeeAll && isTop ? 'calc(100% - 150px)' : '100%'}>
              <div className={headerStyle}>
                <div className={isStepCompleted ? completedNumberCircleStyle : numberCircleStyle}>
                  {isStepCompleted ? <CheckIcon sx={{ fontSize: '20px' }} /> : stackOffset}
                </div>
                <Typography
                  className={titleStyle}
                  sx={{
                    color: isStepCompleted ? 'text.disabled' : isDisabled ? 'text.disabled' : '#1b1b26'
                  }}
                >
                  {title}
                </Typography>
              </div>
              {(!isDisabled || isStepCompleted) && description && (
                <Typography variant='body2' className={descStyle}>
                  {description}
                </Typography>
              )}
            </Stack>

            {isTop && onSeeAll && (
              <Button sx={seeAllStepsButtonSx} onClick={onSeeAll} size='small'>
                See all steps
              </Button>
            )}
          </Box>
        </Box>
      </div>
    </div>
  )
}
